import { memo } from 'react';
import { useTheme } from '@mui/material/styles';
import { Typography, useMediaQuery } from '@mui/material';
import menuItem from 'menu-items';
import NavGroup from './NavGroup';
import useConfig from 'hooks/useConfig';
import { useRole } from 'hooks/api/roles/context';
import LAYOUT_CONST from 'constant';
import { HORIZONTAL_MAX_ITEM } from 'config';

const filterMenuItemsByRole = (items, userRoles) => {
    const filteredItems = items.map((item) => {
        if (item.type === 'group' && item.children) {
            return {
                ...item,
                children: item.children.filter((child) => {
                    // If roles are not specified, show to everyone
                    if (!child.roles) return true;
                    return child.roles.some((role) => userRoles.includes(role));
                })
            };
        }
        return item;
    });

    // Remove groups that have no children after filtering
    return filteredItems.filter((item) => item.type !== 'group' || (item.children && item.children.length > 0));
};

const MenuList = () => {
    const theme = useTheme();
    const { layout } = useConfig();
    const { roles } = useRole();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
    // Filter menu items based on roles
    const filteredMenuItems = {
        ...menuItem,
        items: filterMenuItemsByRole(
            menuItem.items,
            roles.filter((role) => role.active === true).map((role) => role.role.name)
        )
    };

    // last menu-item to show in horizontal menu bar
    const lastItem = layout === LAYOUT_CONST.HORIZONTAL_LAYOUT && !matchDownMd ? HORIZONTAL_MAX_ITEM : null;

    let lastItemIndex = filteredMenuItems.items.length - 1;
    let remItems = [];
    let lastItemId;

    if (lastItem && lastItem < filteredMenuItems.items.length) {
        lastItemId = filteredMenuItems.items[lastItem - 1].id;
        lastItemIndex = lastItem - 1;
        remItems = filteredMenuItems.items.slice(lastItem - 1, filteredMenuItems.items.length).map((item) => ({
            title: item.title,
            elements: item.children
        }));
    }

    const navItems = filteredMenuItems.items.slice(0, lastItemIndex + 1).map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} lastItem={lastItem} remItems={remItems} lastItemId={lastItemId} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default memo(MenuList);
